<template>
  <div class="page-recovery-password text-center pt-2 pr-3 pb-3 pl-3">
    <div class="toolbar text-left mb-4">
      <a href="/" class="btn-back" @click.prevent="$router.push({name: 'LogIn'})">
        <b-icon icon="chevron-left" class="mr-1"/>
        {{ $t("Back") }}</a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <ValidationObserver ref="form" tag="form" class="d-block ml-auto mr-auto" style="width: 400px; max-width: 100%"
                        @submit.prevent="recover()">
      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <label><strong>{{$t('Did you forget your password?')}}</strong></label>
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.email" :placeholder="$t('Mobile / Email')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mail.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group class="mb-1">
        <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">{{
            $t("Password recover")
          }}
        </b-button>
      </b-form-group>
    </ValidationObserver>
    <PanelLoading :show="loading"/>
  </div>
</template>

<script>
import authenticateService from "../services/authenticate_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "PasswordRecovery",
  data: function () {
    return {
      loading: false,
      formData: {
        email: ""
      }
    }
  },
  created() {
    this.setTitle("Password Recovery")
  },
  methods: {
    recover: async function () {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading == true)
        return;

      this.loading = true;
      const response = await authenticateService.passwordRecovery(this.formData);
      this.loading = false;

      if (!response) return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
    }
  }
}
</script>

<style scoped>

</style>